import { defineStore } from "pinia";
import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

export const useLayoutsStore = defineStore("layouts", {
  state: () => ({
    layouts: {} as Record<string, any[]>,
  }),

  getters: {
    getLayouts(state) {
      return state.layouts;
    },

    getLayoutHomePage(state) {
      return state.layouts["2"];
    },
    
    getLayoutsByStoreCode: (state) => (storeCode) => {
      if (!state.layouts || !state.layouts["2"]) return [];
      
      return state.layouts["2"].filter(layout => {
        if (!layout.store_codes) return false;
        
        if (layout.store_codes.includes('vi') && layout.store_codes.includes('mobile')) {
          return true;
        }
        
        return layout.store_codes.includes(storeCode);
      });
    },
  },
  actions: {
    async loadLayouts() {
      try {
        const response = await getApiAxios(api.layout.layout_list);
        this.layouts = response.result;
      } catch (error) {
        console.error("Error fetching layouts:", error);
      }
    },
  },
});
